export default __webpack_public_path__ + "static/media/img_blanketBaseBunny_grey_p.a132e6cb.jpg";